export function splitFavoriteDescription(favoriteDescription: string) {
    let parenCount = 0;
    let startIndex = 0;
    let endIndex = 0;

    for (; endIndex < favoriteDescription.length; endIndex++) {
        if (favoriteDescription[endIndex] === "(") {
            // if this is the very first ( then save its position
            // if its not the first then we need to increment our count
            if (parenCount++ === 0) {
                startIndex = endIndex;
            }
        } else if (favoriteDescription[endIndex] === ")") {
            // if this the matching ) for the first one, as indicated by
            // a parenCount of 0, the break outta here because we're done
            if (--parenCount === 0) {
                break;
            }
        }
    }

    const match = favoriteDescription.substring(startIndex, endIndex + 1);

    if(match === favoriteDescription)    {
        const viewDescription = favoriteDescription;
        const objectDescription = undefined;
    
        return { viewDescription, objectDescription };
    } else {
        const viewDescription = favoriteDescription.replace(match, "");
        const objectDescription = match.substring(1, match.length - 1);
    
        return { viewDescription, objectDescription };
    }
}
